import React, { useState, useEffect } from 'react';
import { getSummaryApi } from '../api/api';
import LoadingSpinner from '../components/LoadingSpinner';
import { IotDevices, IotDevicesModal, SummaryCard } from '../features/summary';

const Summary = () => {
  const [summary, setSummary] = useState({});
  const [isVisible, setIsVisible] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getSummaryApi(
      (data) => {
        if (data) {
          setSummary(data);
          setIsVisible(true);
        }
        setLoading(false);
      },
      (error) => {
        setLoading(false);
      }
    );
  }, []);

  const generalStats = [
    { title: 'Объектов', total: summary?.object_count },
    { title: 'Пользователей', total: summary?.user_count },
  ];

  const deviceStats = [
    { title: 'Счетчиков ХВ', total: summary?.cold_water_count },
    { title: 'Счетчиков ГВ', total: summary?.hot_water_count },
    { title: 'Датчиков протечки', total: summary?.leakage_sensor_count },
    // { title: 'Датчиков температуры', total: summary?.temperature_count },
    { title: 'Универсальных датчиков', total: summary?.universal_count },
    { title: 'Контроллеров', total: summary?.controller_count },
    { title: 'Всего', total: summary?.total },
  ];

  return (
    <div className="bg-gray-100 min-h-screen p-6">
      {loading ? (
        <div className="fixed inset-0 flex justify-center items-center bg-gray-100">
          <LoadingSpinner loading={true} />
        </div>
      ) : (
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Left section: Data */}
          <div className="col-span-1 lg:col-span-2 space-y-6">
            {/* Summary Data */}
            <SummaryCard stats={generalStats} title={'Данные'} isVisible={isVisible} />

            {/* Connected Equipment */}
            <SummaryCard stats={deviceStats} title={'Подключенное оборудование'} isVisible={isVisible} />
            <IotDevices />
          </div>
        </div>
      )}
      <IotDevicesModal />
    </div>
  );
};
export default Summary;
